import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Sparkle } from '@phosphor-icons/react';

export default function AuthCallback() {
  const nav = useNavigate();
  const { setAuthUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav('/login'); return; }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post('/auth/google-session', { session_id }, { withCredentials: true });
        setAuthUser(data.user);
        toast.success(`Welcome, ${data.user.full_name}`);
        // Clean the URL fragment and redirect
        window.history.replaceState(null, '', '/dashboard');
        nav(data.user.role === 'admin' ? '/admin' : '/dashboard', { state: { user: data.user }, replace: true });
      } catch (err) {
        toast.error('Google sign-in failed');
        nav('/login', { replace: true });
      }
    })();
  }, [nav, setAuthUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-lg gradient-orange flex items-center justify-center mx-auto mb-4 animate-pulse shadow-glow-saffron">
          <Sparkle size={26} weight="fill" className="text-white" />
        </div>
        <div className="text-saffron font-heading font-semibold">Signing you in…</div>
      </div>
    </div>
  );
}
